/* eslint-disable @typescript-eslint/no-explicit-any */
import CanvasManager from "./CanvasManager";
import IconManager from "./IconManager";
import { ImageManager } from "./ImageManager";

export interface Strategy {
  execute(item: any, canvasManager: CanvasManager, imageManager: ImageManager, iconManager: IconManager, isSecondLayerVisible?: boolean,): void;

}

class StrategyManager {
  private strategies: Record<string, Strategy> = {};

  registerStrategy(type: string, strategy: Strategy): void {
    this.strategies[type] = strategy;
  }

  getStrategy(type: string): Strategy | undefined {
    return this.strategies[type];
  }
}

export default StrategyManager;
